<template>
	<div class="property" >
		<span class="inline abk">{{property.abk}}</span>
		<span class="inline domain">{{property.domain}}</span>
		<span class="inline onoff">{{property.active_property}}</span>
		<span class="inline actions">
			<a href="#!" v-on:click="showProperty"><i class="fa fa-edit"></i></a>
		</span>		
	</div>
</template>
<script>
export default {
	name: "Property",
	props: ['property'],
	methods: {
		showProperty(e){
			e.preventDefault();
			this.$router.replace({ name: "ManageProperty", params: { propid: this.property.id } })
		}
	}
}
</script>
<style>	
</style>